import * as React from "react";
import Typography from "@mui/material/Typography";
import { Form } from "react-bootstrap";
import { config } from "_config";
import SearchProductItem from "../trademark/SearchProductItem";

export default function ComprehensiveSearchStep3({ state, onChange, validated, searchProductList}) {
  const handleChange = (e) => {
    onChange(e);
  };

  if (config.skin === 'v2-basic') {
    return (
      <div className="question">
        <div className="polaroid">
        <h2 style={{ marginTop: 0 }}>What type of trademark search would you like us to conduct? Select one.</h2>
        <Typography className="regular mb-3">The search you choose will be conducted on the words or text within your trademark.</Typography>
        <Form id="TrademarkForm" noValidate validated={validated}>
          <Form.Group className="mb-3" controlId="searchType">
            {searchProductList ? searchProductList.map((searchProduct, i) => <SearchProductItem key={i} searchProduct={searchProduct}
                                                                      onChange={handleChange}
                                                                      searchType={state.searchType} />) : null}
          </Form.Group>
        </Form>
        </div>
      </div>
    );
  }

  return (
    <div className="question">
      <h2>What type of trademark search would you like us to conduct? Select one.</h2>
      <Typography className="regular mb-3">The search you choose will be conducted on the words or text within your trademark.</Typography>
      <Form id="TrademarkForm" noValidate validated={validated}>
        <Form.Group className="mb-3" controlId="searchType">
          {searchProductList ? searchProductList.map((searchProduct, i) => <SearchProductItem key={i} searchProduct={searchProduct}
                                                                     onChange={handleChange}
                                                                     searchType={state.searchType} />) : null}
        </Form.Group>
      </Form>
    </div>
  );
}
